// Mock data for Documents and Extraction Drawer
import { formatRelativeTime as formatLocalizedRelativeTime } from './dateUtils';

export const EXTRACTION_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETE: 'complete',
  FAILED: 'failed',
};

export const EXTRACTION_RESULTS_BY_DOC = {
  'doc-fascicolo': {
    cuaa: 'IT12345678901',
    farmName: 'Azienda Agricola Verde',
    legalForm: 'Societa Agricola Srl',
    vatNumber: 'IT09876543210',
    address: 'Via Roma 123, 00100 Roma, Italia',
    representative: 'Marco Rossi',
    landAreaHa: '45.2',
    mainCrop: 'Vite da vino',
    updatedAt: '2024-11-15',
  },
  'doc-project-map': {
    projectName: 'Azienda Agricola Verde',
    mapScale: '1:5000',
    coordinateSystem: 'WGS84 / UTM 33N',
    totalParcels: '12',
    totalAreaHa: '45.2',
    irrigationPoints: '4',
    stationCount: '4',
    mapDate: '2024-11-10',
  },
  'doc-year1-report': {
    reportYear: '2023',
    vineyardAreaHa: '28.5',
    averageYield: '8.5 t/ha',
    plvPerHa: 'EUR 12,500/ha',
    irrigationMethod: 'Drip',
    diseaseEvents: '1 mildew event',
    compiledBy: 'Dr. Marco Rossi',
    reportDate: '2024-11-14',
  },
  'doc-previous-annual': {
    reportYear: '2023',
    totalPlv: 'EUR 156,000',
    totalHectares: '45.2',
    totalProduction: '385 t',
    weatherEvents: '2 hail events',
    inputCosts: 'EUR 48,300',
    reportDate: '2024-11-13',
  },
  'doc-invoice': {
    invoiceNumber: 'INV-2024-001',
    date: '2024-01-15',
    amount: 'EUR 1,250.00',
    supplier: 'AgriSupply S.r.l.',
    description: 'Water supply invoice for Q1 2024',
    paymentTerms: 'Net 30',
    dueDate: '2024-02-14',
  },
  'doc-soil-test': {
    sampleDate: '2024-11-05',
    fieldId: 'Field A-3',
    phLevel: '6.8',
    organicMatter: '3.2%',
    nitrogen: '45 mg/kg',
    phosphorus: '22 mg/kg',
    potassium: '180 mg/kg',
    soilTexture: 'Loam',
  },
  'doc-water-usage': {
    period: 'Q1-Q3 2024',
    totalUsageM3: '12,500',
    avgDailyM3: '45',
    waterSource: 'Consorzio Idrico Locale',
    irrigationMethod: 'Drip + Sprinkler',
    efficiencyRating: 'A',
    reportDate: '2024-11-18',
  },
};

// Base documents available for all report types
const DOC_FASCICOLO = {
  id: 'doc-fascicolo',
  name: 'Fascicolo_Aziendale_2024.pdf',
  type: 'pdf',
  size: 2456789,
  uploadedAt: new Date('2024-11-15T10:30:00'),
  uploadedBy: 'Dr. Marco Rossi',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'CUAA', value: 'IT12345678901', confidence: 0.98, source: 'Fascicolo_Aziendale_2024.pdf' },
      { name: 'Legal Form', value: 'Società Agricola', confidence: 0.95, source: 'Fascicolo_Aziendale_2024.pdf' },
      { name: 'Address', value: 'Via Roma 123, 00100 Rome, Italy', confidence: 0.92, source: 'Fascicolo_Aziendale_2024.pdf' },
      { name: 'Land Area', value: '45.2 ha', confidence: 0.89, source: 'Fascicolo_Aziendale_2024.pdf' },
    ],
    extractedAt: new Date('2024-11-15T10:35:00'),
  },
  url: '/documents/Fascicolo_Aziendale_2024.pdf',
};

const DOC_PROJECT_MAP = {
  id: 'doc-project-map',
  name: 'Mappa_Progetto_2024.pdf',
  type: 'pdf',
  size: 3456789,
  uploadedAt: new Date('2024-11-15T11:00:00'),
  uploadedBy: 'Dr. Marco Rossi',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'Project Name', value: 'Azienda Agricola Verde', confidence: 0.96, source: 'Mappa_Progetto_2024.pdf' },
      { name: 'Total Parcels', value: '12', confidence: 0.94, source: 'Mappa_Progetto_2024.pdf' },
      { name: 'Station Count', value: '4', confidence: 0.92, source: 'Mappa_Progetto_2024.pdf' },
    ],
    extractedAt: new Date('2024-11-15T11:05:00'),
  },
  url: '/documents/Mappa_Progetto_2024.pdf',
};

const DOC_YEAR1_REPORT = {
  id: 'doc-year1-report',
  name: 'Relazione_Agronomica_Anno1.pdf',
  type: 'pdf',
  size: 4567890,
  uploadedAt: new Date('2024-11-14T09:00:00'),
  uploadedBy: 'Dr. Marco Rossi',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'Report Year', value: '2023', confidence: 0.98, source: 'Relazione_Agronomica_Anno1.pdf' },
      { name: 'Crop Type', value: 'Vite da vino', confidence: 0.95, source: 'Relazione_Agronomica_Anno1.pdf' },
      { name: 'Yield', value: '8.5 t/ha', confidence: 0.92, source: 'Relazione_Agronomica_Anno1.pdf' },
      { name: 'PLV', value: '€12,500/ha', confidence: 0.91, source: 'Relazione_Agronomica_Anno1.pdf' },
    ],
    extractedAt: new Date('2024-11-14T09:10:00'),
  },
  url: '/documents/Relazione_Agronomica_Anno1.pdf',
};

const DOC_PREVIOUS_ANNUAL = {
  id: 'doc-previous-annual',
  name: 'Relazione_Agronomica_Annuale_Precedente.pdf',
  type: 'pdf',
  size: 5678901,
  uploadedAt: new Date('2024-11-13T14:00:00'),
  uploadedBy: 'Dr. Marco Rossi',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'Report Year', value: '2023', confidence: 0.97, source: 'Relazione_Agronomica_Annuale_Precedente.pdf' },
      { name: 'Total PLV', value: '€156,000', confidence: 0.94, source: 'Relazione_Agronomica_Annuale_Precedente.pdf' },
      { name: 'Hectares', value: '45.2 ha', confidence: 0.96, source: 'Relazione_Agronomica_Annuale_Precedente.pdf' },
      { name: 'Weather Events', value: '2 hail events', confidence: 0.89, source: 'Relazione_Agronomica_Annuale_Precedente.pdf' },
    ],
    extractedAt: new Date('2024-11-13T14:15:00'),
  },
  url: '/documents/Relazione_Agronomica_Annuale_Precedente.pdf',
};

// Utility documents - included in all report types
const DOC_INVOICE = {
  id: 'doc-invoice',
  name: 'Invoice_2024_01.pdf',
  type: 'pdf',
  size: 1234567,
  uploadedAt: new Date('2024-11-16T14:20:00'),
  uploadedBy: 'Admin User',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'Invoice Number', value: 'INV-2024-001', confidence: 0.97, source: 'Invoice_2024_01.pdf' },
      { name: 'Date', value: '2024-01-15', confidence: 0.94, source: 'Invoice_2024_01.pdf' },
      { name: 'Amount', value: '€1,250.00', confidence: 0.91, source: 'Invoice_2024_01.pdf' },
      { name: 'Supplier', value: 'AgriSupply S.r.l.', confidence: 0.88, source: 'Invoice_2024_01.pdf' },
    ],
    extractedAt: new Date('2024-11-16T14:25:00'),
  },
  url: '/documents/Invoice_2024_01.pdf',
};

const DOC_SOIL_TEST = {
  id: 'doc-soil-test',
  name: 'Soil_Test_Report_2024.xlsx',
  type: 'xlsx',
  size: 567890,
  uploadedAt: new Date('2024-11-17T09:15:00'),
  uploadedBy: 'Dr. Marco Rossi',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'pH Level', value: '6.8', confidence: 0.95, source: 'Soil_Test_Report_2024.xlsx' },
      { name: 'Organic Matter', value: '3.2%', confidence: 0.93, source: 'Soil_Test_Report_2024.xlsx' },
      { name: 'Nitrogen', value: '45 mg/kg', confidence: 0.91, source: 'Soil_Test_Report_2024.xlsx' },
    ],
    extractedAt: new Date('2024-11-17T09:20:00'),
  },
  url: '/documents/Soil_Test_Report_2024.xlsx',
};

const DOC_WATER_USAGE = {
  id: 'doc-water-usage',
  name: 'Water_Usage_Report_2024.pdf',
  type: 'pdf',
  size: 1890123,
  uploadedAt: new Date('2024-11-18T11:45:00'),
  uploadedBy: 'Admin User',
  extractionStatus: EXTRACTION_STATUS.COMPLETE,
  extractionResults: {
    fields: [
      { name: 'Total Usage', value: '12,500 m³', confidence: 0.94, source: 'Water_Usage_Report_2024.pdf' },
      { name: 'Period', value: 'Q1-Q3 2024', confidence: 0.96, source: 'Water_Usage_Report_2024.pdf' },
      { name: 'Efficiency Rating', value: 'A', confidence: 0.89, source: 'Water_Usage_Report_2024.pdf' },
    ],
    extractedAt: new Date('2024-11-18T11:50:00'),
  },
  url: '/documents/Water_Usage_Report_2024.pdf',
};

// Common utility documents included in all reports
const COMMON_DOCUMENTS = [DOC_INVOICE, DOC_SOIL_TEST, DOC_WATER_USAGE];

// Documents by report type (suggested docs + common utility docs)
export const DOCUMENTS_BY_REPORT_TYPE = {
  relazione_agronomica_primo_anno: [DOC_FASCICOLO, DOC_PROJECT_MAP, ...COMMON_DOCUMENTS],
  relazione_agronomica_annuale: [DOC_FASCICOLO, DOC_PROJECT_MAP, DOC_YEAR1_REPORT, ...COMMON_DOCUMENTS],
  plv_drop_report: [DOC_FASCICOLO, DOC_PREVIOUS_ANNUAL, ...COMMON_DOCUMENTS],
};

// Legacy export for backward compatibility
export const MOCK_DOCUMENTS = [DOC_FASCICOLO, DOC_PROJECT_MAP, ...COMMON_DOCUMENTS];

// Helper to get documents for a specific report type
export function getDocumentsForReportType(reportType) {
  return DOCUMENTS_BY_REPORT_TYPE[reportType] || DOCUMENTS_BY_REPORT_TYPE.relazione_agronomica_primo_anno;
}

// Helper function to get file type icon
export function getFileTypeIcon(type) {
  const icons = {
    pdf: '📄',
    doc: '📝',
    docx: '📝',
    xls: '📊',
    xlsx: '📊',
    jpg: '🖼️',
    jpeg: '🖼️',
    png: '🖼️',
  };
  return icons[type.toLowerCase()] || '📄';
}

// Helper function to format file size
export function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
}

// Helper function to format relative time
export function formatRelativeTime(date, locale, t) {
  return formatLocalizedRelativeTime(date, locale, t);
}

// Helper function to get confidence color
export function getConfidenceColor(confidence) {
  if (confidence >= 0.9) return 'success';
  if (confidence >= 0.7) return 'warning';
  return 'danger';
}

// Helper function to get confidence label
export function getConfidenceLabel(confidence) {
  if (confidence >= 0.9) return 'High';
  if (confidence >= 0.7) return 'Medium';
  return 'Low';
}

// Generate mock extracted data
export function generateMockExtractedData(document) {
  if (document) {
    const idSuffix = typeof document.id === 'string'
      ? document.id.replace(/[^0-9]/g, '').slice(-4)
      : '';
    const referenceId = idSuffix ? `REF-${idSuffix}` : 'REF-0000';

    return {
      documentName: document.name || 'Uploaded document',
      fileType: document.type || 'file',
      uploadedBy: document.uploadedBy || 'User',
      referenceId,
      processedAt: new Date().toISOString().slice(0, 10),
    };
  }
  return {
    invoiceNumber: 'INV-2025-001',
    date: '2025-01-15',
    amount: 1250.00,
    supplier: 'Water Supply Co.',
    description: 'Water supply invoice for Q1 2025',
    paymentTerms: 'Net 30',
    dueDate: '2025-02-14',
  };
}

export function getExtractionResultsForDocument(document) {
  if (!document) {
    return generateMockExtractedData();
  }
  return EXTRACTION_RESULTS_BY_DOC[document.id] || generateMockExtractedData(document);
}

// Simulate extraction
export function simulateExtraction(documentId, delay = 2000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        fields: [
          { name: 'Sample Field', value: 'Sample Value', confidence: 0.85, source: 'document.pdf' },
        ],
        extractedAt: new Date(),
      });
    }, delay);
  });
}
